(function () {
  'use strict';

  // 在这里填写需要 fadeup 的组件：tag 为自定义标签名，items 为内部需要动画的元素选择器
  var ANIMATE_SECTIONS = [
    {
      tag: 'dl-page-autoplay-gallery-h',
      items: [
        '.dl-page-autoplay-gallery-h-title',
        '.dl-page-autoplay-gallery-h-container'
      ]
    },
    {
      tag: 'dl-page-scan-x',
      items: [
        '.dl-page-scan-X-title',
        '.dl-page-scan-X-content-left',
        '.dl-page-scan-X-content-right-image',
        '.dl-page-scan-X-content-right-content'
      ]
    },
    {
      tag: 'dl-product-part-three-images-h',
      items: [
        '.dl-product-part-h-title',
        '.dl-product-part-three-images-h-item-image',
        '.dl-product-part-three-images-h-item-title',
        '.dl-product-part-three-images-h-item-desc',
        '.dl-product-part-three-images-h-item-note'
      ]
    },
    {
      tag: 'dl-product-part-single-image-h',
      items: [
        '.dl-product-part-h-title',
        '.product-part-single-image-h-subtitle',
        '.product-part-single-image-h img',
        '.product-part-single-image-h video',
        '.product-part-single-image-h-note'
      ]
    },
    {
      tag: 'dl-product-part-list-h',
      items: [
        '.dl-product-part-detail-h-title',
        '.dl-product-part-list-h-part'
      ]
    },
    {
      tag: 'dl-product-part-image-with-text-h',
      items: [
        '.product-part-image-with-text-h-item-image',
        '.product-part-image-with-text-h-item-title',
        '.product-part-image-with-text-h-item-desc',
        '.product-part-image-with-text-h-item-note',
        '.product-part-image-with-text-h-note'
      ]
    },
    {
      tag: 'dl-page-addtocart-x',
      items: [
        '.dl-page-addtocart-x-title',
        '.dl-page-addtocart-x-image',
        '.dl-page-addtocart-x-product'
      ]
    },
    {
      tag: 'dl-page-swiper-pop-h',
      items: [
        '.dl-page-swiper-pop-h-item-media',
        '.dl-page-swiper-pop-h-item-title',
        '.dl-page-swiper-pop-h-item-desc',
        '.dl-page-swiper-pop-h-item-points-desc',
        '.dl-page-swiper-pop-h-item-pop-btn',
        '.dl-page-swiper-pop-h-item-footer-title',
        '.dl-page-swiper-pop-h-item-footer-content'
      ]
    }
  ];

  var VISIBLE_CLASS = 'animate_visible';
  var READY_CLASS = 'animate_ready';
  var SECTION_ACTIVE_CLASS = 'animate_go';
  var SECTION_CLASS = 'dl-animate-section';

  function getSectionConfig(section) {
    var tagName = section.tagName.toLowerCase();
    for (var i = 0; i < ANIMATE_SECTIONS.length; i++) {
      if (ANIMATE_SECTIONS[i].tag === tagName) return ANIMATE_SECTIONS[i];
    }
    return null;
  }

  function getSectionSelector() {
    return ANIMATE_SECTIONS
      .map(function (config) { return String(config.tag || '').trim(); })
      .filter(Boolean)
      .join(', ');
  }

  function getItems(section) {
    var config = getSectionConfig(section);
    if (!config || !config.items || !config.items.length) return [];
    return Array.prototype.slice.call(
      section.querySelectorAll(config.items.join(', '))
    );
  }

  function prepareItem(item, index) {
    if (item.dataset.dlAnimateReady) return;
    item.dataset.dlAnimateReady = '1';
    item.dataset.effectName = item.dataset.effectName || 'fadeup-1';
    item.style.setProperty('--dl-animate-delay', (index % 4 * 120) + 'ms');
    item.classList.add('animate_definition', 'transitionable', READY_CLASS);
  }

  function showSection(section) {
    section.classList.add(SECTION_ACTIVE_CLASS);
    getItems(section).forEach(function (item) {
      item.classList.add(VISIBLE_CLASS);
    });
  }

  function initSection(section, observer) {
    if (section.dataset.dlAnimateSectionReady) return;
    section.dataset.dlAnimateSectionReady = '1';
    section.classList.add(SECTION_CLASS);

    getItems(section).forEach(prepareItem);

    if (!('IntersectionObserver' in window)) {
      showSection(section);
      return;
    }

    observer.observe(section);
  }

  function init() {
    var sectionSelector = getSectionSelector();
    if (!sectionSelector) return;

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          showSection(entry.target);
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.15
      });
    }

    document.querySelectorAll(sectionSelector).forEach(function (section) {
      initSection(section, observer);
    });

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches(sectionSelector)) {
              initSection(node, observer);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll(sectionSelector).forEach(function (section) {
                initSection(section, observer);
              });
            }
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
